import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'telus-bulk-dropdown',
  templateUrl: 'dropdown.html',
  styleUrls: ['./dropdown.scss'],
})
export class DropdownComponent {
  @Input() actions: string[];

  @Output() selectedAction = new EventEmitter<string>();

  constructor() {}

  onAction(action: string) {
    this.selectedAction.emit(action);
  }
}
